import React from "react";
import { Modal, Table } from "react-bootstrap";
import { styles, theme } from "./theme";

interface FullscreenModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  data?: any[]; // Data to display in the table
}

const FullscreenModal: React.FC<FullscreenModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  data = []
}) => {
  // Get table headers from the first data item if it exists
  const tableHeaders = data && data.length > 0 ? Object.keys(data[0]) : [];

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="xl"
      centered
      style={{
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      contentClassName="custom-modal-content fullscreen-modal-override"
      dialogClassName="custom-modal-dialog"
      dialogStyle={modalStyles.dialog}
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: '1px solid #eee',
          padding: '1rem 1.5rem'
        }}
      >
        <Modal.Title
          as="h2"
          style={{
            margin: 0,
            color: theme.colors.primary
          }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          padding: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem'
        }}
      >
        {/* Main Content */}
        <div style={{ flex: 1, minHeight: '40vh', position: 'relative' }}>
          {children}
        </div>

        {/* Data Table */}
        {data && data.length > 0 && (
          <div style={{ marginTop: '1.5rem' }}>
            <h6 style={{
              marginBottom: '1rem',
              color: theme.colors.text,
              fontWeight: 600
            }}>
              📊 Data table
            </h6>
            <div style={{
              maxHeight: '40vh',
              overflowY: 'auto',
              border: '1px solid #eee',
              borderRadius: '4px'
            }}>
              <Table striped bordered hover responsive>
                <thead style={{ position: 'sticky', top: 0, background: 'white' }}>
                  <tr>
                    {tableHeaders.map((header, index) => (
                      <th key={index} style={{
                        padding: '0.75rem',
                        backgroundColor: theme.colors.primary,
                        color: 'white',
                        textTransform: 'capitalize'
                      }}>
                        {header.replace(/_/g, ' ')}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {tableHeaders.map((header, colIndex) => (
                        <td key={colIndex} style={{
                          padding: '0.75rem',
                          verticalAlign: 'middle'
                        }}>
                          {row[header] !== null && row[header] !== undefined
                            ? String(row[header])
                            : '-'}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

// Inline styles for the modal
const modalStyles = {
  dialog: {
    width: '1400px',
    margin: '1.75rem auto',
    height: '95vh',
    '& .modal-content': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    '@media (max-width: 768px)': {
      width: '100vw',
      margin: 0,
      height: '100vh',
      maxWidth: '100%',
    },
  },
};

export default FullscreenModal;

// CSS override to remove max-width from global modal-content styles
const style = document.createElement('style');
style.textContent = `
  .fullscreen-modal-override.modal-content {
    max-width: none !important;
    width: 100% !important;
  }
`;
if (!document.head.querySelector('style[data-fullscreen-modal-override]')) {
  style.setAttribute('data-fullscreen-modal-override', 'true');
  document.head.appendChild(style);
}